import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "nav-links"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://geospatial.com/support/",
  target: "_blank",
  rel: "noopener"
}, " Support ")], -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://geospatial.com/about-us/",
  target: "_blank",
  rel: "noopener"
}, " About ")], -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://geospatial.com/contact-us/",
  target: "_blank",
  rel: "noopener"
}, " Contact ")], -1);
const _hoisted_5 = [_hoisted_2, _hoisted_3, _hoisted_4];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("ul", _hoisted_1, _hoisted_5);
}